import { DeprecatedRoute } from '/@/modules/auth/routes/deprecated.routes';

export const router = [
  {
    path: `/${DeprecatedRoute.DEPRECATEDLAYOUT.path}`,
    name: DeprecatedRoute.DEPRECATEDLAYOUT.name,
    component: () => import('/@/modules/auth/pages/DeprecatedLayout.vue'),
    meta: { guestOnly: true },
    children: [
      {
        path: `/${DeprecatedRoute.CLEAR_WILL.path}`,
        name: DeprecatedRoute.CLEAR_WILL.name,
        component: () => import('/@/modules/auth/pages/ClearWillDeprecatedPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${DeprecatedRoute.DEPRECATED_CLEAR_WILL.path}`,
        name: DeprecatedRoute.CLEAR_WILL.name,
        component: () => import('/@/modules/auth/pages/ClearWillDeprecatedPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${DeprecatedRoute.MAKE_A_WILL.path}`,
        name: DeprecatedRoute.MAKE_A_WILL.name,
        component: () => import('/@/modules/auth/pages/ClearWillDeprecatedPage.vue'),
        meta: { guestOnly: true }
      }
    ]
  }
];
